import { observer } from 'mobx-react-lite'
import { Button, SpinnerLoader, Typography } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type Integration } from 'entities/Integrations'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationTwilioSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationTwilioSettings/store/IntegrationTwilioSettingsStore'
import styles from './styles.module.scss'

type IIntegrationTwilioSettings = {
  integration: Integration
}

export const IntegrationTwilioSettings = observer(({ integration }: IIntegrationTwilioSettings) => {
  const entities = useEntitiesContext()
  const store = useIntegrationStoreMemo(IntegrationTwilioSettingsStore, integration, entities)
  const { keyLabel, keyValue, secretLabel, maskedSecretValue, openChangeModal } = store

  if (store.loading) {
    return <SpinnerLoader ariaLabel={'IntegrationTwilioSettings'} />
  }

  return (
    <div className={styles.container}>
      <Typography
        ariaLabel={'IntegrationTwilioSettings_title'}
        variant={'body-lg-medium'}
        tag={'div'}
        marginBottom={10}
      >
        Credentials
      </Typography>

      <div className={styles.fields}>
        <TitledRow title={keyLabel} className={styles.row} align={'normal'}>
          <TextField
            className={styles.textField}
            variant={'stroke'}
            size={'medium'}
            value={keyValue}
            readOnly
            noDisabledWhenReadOnly
          />
        </TitledRow>
        <TitledRow title={secretLabel} className={styles.row} align={'normal'}>
          <TextField
            className={styles.textField}
            variant={'stroke'}
            size={'medium'}
            value={maskedSecretValue}
            readOnly
            noDisabledWhenReadOnly
          />
        </TitledRow>
      </div>
      <Button
        text={'Update credentials'}
        typeBtn={'contained'}
        contained={'primary'}
        size={'medium'}
        onClick={openChangeModal}
      />
    </div>
  )
})
